// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2DrxL","location":"Header_location__1rFJI"};